/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { PureComponent } from 'react';
import { shape, bool, number, func, instanceOf } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'clsx';

import ShoppingBag from 'gfx/vector/shopping-bag-icon.svg';

import {
  showShortlistBasket as showShortlistBasketAction,
  hideShortlistBasket as hideShortlistBasketAction,
} from 'actions/shortlist';

import Spinner from 'components/Spinner/Spinner';
import Counter from 'components/Counter/Counter';

import styles from './shortlist-button.scss';

/**
 * This is the ShortlistButton component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class ShortlistButton extends PureComponent {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    white: bool,
    shortlist: shape({
      visible: bool,
      loading: bool,
      requests: shape({
        talent_count: number,
      }),
    }).isRequired,
    showShortlistBasket: func.isRequired,
    hideShortlistBasket: func.isRequired,
    innerRef: shape({ current: instanceOf(Element) }).isRequired,
  };

  onClick = event => {
    event.preventDefault();

    const {
      shortlist: { visible },
      showShortlistBasket,
      hideShortlistBasket,
    } = this.props;

    if (visible) {
      hideShortlistBasket();
    } else {
      showShortlistBasket();
    }
  };

  /**
   * Render ShortlistButton.
   *
   * @return {Object}
   */
  render() {
    const {
      white,
      shortlist: {
        loading,
        requests: { talent_count },
      },
      innerRef,
    } = this.props;

    return (
      <button
        ref={innerRef}
        type="button"
        className={classNames(styles.wrapper, {
          [styles.loading]: loading,
        })}
        onClick={this.onClick}
      >
        <ShoppingBag
          className={classNames(styles.icon, {
            [styles.white]: white,
          })}
        />
        {!loading && talent_count > 0 && (
          <Counter accent count={talent_count} />
        )}
        {loading && (
          <span className={styles.spinner}>
            <Spinner small />
          </span>
        )}
      </button>
    );
  }
}

export default connect(({ shortlist }) => ({ shortlist }), {
  showShortlistBasket: showShortlistBasketAction,
  hideShortlistBasket: hideShortlistBasketAction,
})(ShortlistButton);
